import Api from './api';

export default {
  getAllAnnouncements: () => Api.get('announcements'),
};
